
import axios from 'axios';

if (typeof (uni) !== 'undefined' && uni.request) {
  // 适配uniapp/小程序网络请求。否则会直接导致网络请求失败
  axios.defaults.adapter = function (config) {
    return new Promise((resolve, reject) => {
      const settle = require('axios/lib/core/settle');
      const buildURL = require('axios/lib/helpers/buildURL');
      const url = new RegExp('^http(s)?://').test(config.url) ? config.url : config.baseURL + config.url; // 判断时相对路径还是绝对路径，相对路径添加config.baseURL
      uni.request({
        method: config.method.toUpperCase(),
        url: buildURL(url, config.params, config.paramsSerializer),
        header: config.headers,
        data: config.data,
        dataType: config.dataType,
        responseType: config.responseType,
        sslVerify: config.sslVerify,
        complete: function complete(response) {
          const res = {
            data: response.data,
            status: response.statusCode,
            errMsg: response.errMsg,
            header: response.header,
            config,
          };
          settle(resolve, reject, res);
        },
      });
    });
  };
}